import React from 'react';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';

import { formatarTelefone } from '../../../utils/telefoneHelper';

export default (props) => {
	const {
		isOpenVisualizar,
		handleCloseVisualizar,
		entidade,
	} = props;
	return (
		<WidgetModalForm
			initialValues={entidade}
			iconCancelar='fas fa-times'
			textCancelar='Fechar'
			title='Visualizar entidade'
			isOpen={isOpenVisualizar}
			cancelar={handleCloseVisualizar}
			tamanho='lg'
		>
			<ModalFormContext.Consumer>
				{({ values }) => (
					<React.Fragment>
						<div className='row'>
							<div className='col-md-12 pl-0 pr-0'>
								{values.nome !== null && (
									<React.Fragment>
										<div className='col-12'>
											<strong>Entidade:</strong>
											<p className='text-break'>{values.nome}</p>
										</div>

										<div className='d-flex'>
											<div className='col-6'>
												<strong>CNPJ:</strong>
												<p>{values.cnpj}</p>
											</div>
											<div className='col-6'>
												<strong>E-mail:</strong>
												<p className='text-break'>{values.email}</p>
											</div>
										</div> {/* d-flex */}

										<div className='d-flex'>
											<div className='col-6'>
												<strong>Telefone principal:</strong>
												<p>{formatarTelefone(values.telefonePrincipal)}</p>
											</div>
											<div className='col-6'>
												<strong>Telefone secundário:</strong>
												<p>{formatarTelefone(values.telefoneSecundario)}</p>
											</div>
										</div> {/* d-flex */}

										<div className='d-flex'>
											<div className='col-6'>
												<strong>CEP:</strong>
												<p>{values.endereco.cep}</p>
											</div>
											<div className='col-6'>
												<strong>Município:</strong>
												<p>{values.endereco.municipio.nome}</p>
											</div>
										</div> {/* d-flex */}

										<div className='d-flex'>
											<div className='col-6'>
												<strong>Logradouro:</strong>
												<p>{values.endereco.logradouro}</p>
											</div>
											<div className='col-6'>
												<strong>Bairro:</strong>
												<p>{values.endereco.bairro}</p>
											</div>
										</div> {/* d-flex */}

										<div className='d-flex'>
											<div className='col-6'>
												<strong>Número:</strong>
												<p>{values.endereco.numero}</p>
											</div>
											<div className='col-6'>
												<strong>Complemento:</strong>
												<p className='text-break'>{values.endereco.complemento || '--'}</p>
											</div>
										</div> {/* d-flex */}
									</React.Fragment>
								)}
							</div> {/* col-md-12 pl-0 pr-0 */}
						</div> {/* .row */}
					</React.Fragment>
				)}
			</ModalFormContext.Consumer>
		</WidgetModalForm>
	);
};
